import { toast } from 'react-toastify';
import React from 'react';
import { z } from 'zod';
import {
  NOTIFICATIONS,
  NOTIFICATIONS_ID,
  TYPE_NOTIFICATION_BY_ID
} from '@portal/shared/ui/Notification/constants';
import Notification from './Notification';
import { NotificationConfig, NotificationConfigCallbackOptions } from './Notification.types';
import classes from './NotificationContainer.module.scss';

export function showCustomNotification({
  props,
  toastOptions,
  type,
  willUpdate,
  updatedProps,
  timer
}: NotificationConfig) {
  let typeToastOptions = toastOptions;
  let typeProps = props;

  if (type) {
    typeProps = {
      ...props,
      type
    };
    typeToastOptions = {
      ...toastOptions,
      bodyClassName: `${classes.Toast__Body} ${classes[`Toast__Body_${type}`]}`,
      progressClassName: `${classes.Toast__Progress} ${classes[`Toast__Progress_${type}`]}`
    };
  }
  toast(<Notification {...typeProps} />, typeToastOptions);

  if (typeToastOptions && willUpdate && updatedProps)
    setTimeout(() => {
      if (typeToastOptions!.toastId)
        toast.update(typeToastOptions!.toastId, {
          render: <Notification {...updatedProps} />,
          type: toast.TYPE.INFO,
          autoClose: timer,
          hideProgressBar: true
        });
    }, timer);
}

export function showNotification(
  id: z.infer<typeof NOTIFICATIONS_ID>,
  options: NotificationConfigCallbackOptions = {}
) {
  if (id in NOTIFICATIONS) {
    const notificationConfig = NOTIFICATIONS[id];
    const notificationConfigValue =
      typeof notificationConfig === 'function' ? notificationConfig(options) : notificationConfig;

    if (notificationConfigValue) {
      const { props, toastOptions } = notificationConfigValue;

      showCustomNotification({
        props,
        toastOptions: {
          ...toastOptions,
          toastId: id
        },
        type: TYPE_NOTIFICATION_BY_ID[id]
      });
    }
  }
}
